/*
  This VueX Module is used to centrally store search results. 
  Reason: HeroSection from LandingPage as well as Search Engine (CatalogueApp) perform product searches that are displayed on the same SearchResults page.
*/
const state = {
  searchResult: {}
};
const getters = {
  searchResult: (state) => state.searchResult,
};
const mutations = {
  setSearchResult (state, searchResult){
    console.log("INSIDE VUEX")
    state.searchResult = searchResult
    console.log(searchResult)
  }
};
export default {
  state,
  getters,
  mutations,
};
